module.exports = __webpack_public_path__ + "static/media/2minutes.aec352bf.mp3";